import { render, staticRenderFns } from "./Administrator.vue?vue&type=template&id=72dea907&scoped=true"
import script from "./Administrator.vue?vue&type=script&lang=js"
export * from "./Administrator.vue?vue&type=script&lang=js"
import style0 from "./Administrator.vue?vue&type=style&index=0&id=72dea907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dea907",
  null
  
)

export default component.exports